// searchstore.ts
import { makeAutoObservable } from 'mobx';

// Константа с игнорируемыми полями
const IGNORED_COLUMNS: string[] = ['Color 2', 'quantity', 'photo', 'фото 2'];

// Тип для хранения уникальных значений полей
interface FieldValues {
  [key: string]: Set<string | number>;
}

class ProductStore {
  products: Product[] = [];
  searchActive: boolean = false;
  // Новое поле для хранения уникальных значений
  fieldValues: FieldValues = {};

  constructor() {
    makeAutoObservable(this);
  }

  setProducts(data: Product[]) {
    this.products = data;
    // Если поиск активен, обрабатываем данные
    if (this.searchActive) {
      this.processProductFields();
    }
  }
  setSearchActive(active: boolean) {
    this.searchActive = active;
  }

  // Новая функция для обработки полей товаров
  processProductFields() {
    // Инициализируем объект для хранения уникальных значений
    const fieldValues: FieldValues = {};

    // Обрабатываем каждый товар
    this.products.forEach((product) => {
      // Перебираем все поля товара
      Object.entries(product).forEach(([key, value]) => {
        // Пропускаем игнорируемые поля и null/undefined значения
        if (IGNORED_COLUMNS.includes(key) || value == null) {
          return;
        }

        // Если для этого поля еще нет набора значений, создаем его
        if (!fieldValues[key]) {
          fieldValues[key] = new Set();
        }

        // Добавляем значение в набор (Set автоматически удаляет дубликаты)
        fieldValues[key].add(value);
      });
    });

    // Сохраняем обработанные данные
    this.fieldValues = fieldValues;
  }

  // Геттер для получения уникальных значений полей в виде объекта с массивами
  getFieldValues(): { [key: string]: (string | number)[] } {
    const result: { [key: string]: (string | number)[] } = {};

    // Собираем все уникальные значения полей из текущих результатов поиска
    if (this.products.length > 0) {
      // Создаем временный объект для хранения уникальных значений
      const tempValues: { [key: string]: Set<string | number> } = {};

      // Обрабатываем каждый товар
      this.products.forEach((product) => {
        // Перебираем все поля товара
        Object.entries(product).forEach(([key, value]) => {
          // Пропускаем игнорируемые поля и null/undefined значения
          if (IGNORED_COLUMNS.includes(key) || value == null) {
            return;
          }

          // Если для этого поля еще нет набора значений, создаем его
          if (!tempValues[key]) {
            tempValues[key] = new Set();
          }

          // Добавляем значение в набор (Set автоматически удаляет дубликаты)
          tempValues[key].add(value);
        });
      });

      // Преобразуем Set в массивы для результата
      Object.entries(tempValues).forEach(([key, valueSet]) => {
        result[key] = Array.from(valueSet);
      });
    } else {
      // Если нет результатов поиска, используем сохраненные значения полей
      Object.entries(this.fieldValues).forEach(([key, valueSet]) => {
        result[key] = Array.from(valueSet);
      });
    }

    return result;
  }
}

const productStore = new ProductStore();
export default productStore;
